import { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export interface AccordionItem {
  id: string | number;
  title: React.ReactNode;
  content: React.ReactNode;
  indicatorColor?: string;
  icon?: string;
}

interface AccordionListProps {
  items: AccordionItem[];
}

const AccordionList = ({ items }: AccordionListProps) => {
  const [expanded, setExpanded] = useState<string | number | false>(false);

  const handleChange =
    (panel: string | number) =>
    (_event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <div
      style={{
        width: "100%",
        borderBottom: "1px solid #77797b",
        borderTop: "1px solid #77797b",
      }}
    >
      {items.map((item) => (
        <Accordion
          key={item.id}
          expanded={expanded === item.id}
          onChange={handleChange(item.id)}
          disableGutters
          elevation={0}
          square
          sx={{
            ...(item.indicatorColor && {
              borderLeft: `6px solid ${item.indicatorColor}`,
            }),

            "&.Mui-expanded": {
              margin: 0,
            },
            "&.Mui-expanded::before": {
              backgroundColor: "#77797b !important",
              opacity: 1,
            },
            "&::before": {
              backgroundColor: "#77797b",
              opacity: 1,
            },
          }}
          slotProps={{
            transition: {
              unmountOnExit: true,
            },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              minHeight: "56px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {item.icon && (
                <div
                  style={{
                    position: "relative",
                    width: "24px",
                    height: "24px",
                  }}
                >
                  <img
                    src={item.icon}
                    alt="Icone ilustrativo do status da classificação"
                    style={{ width: "24px", height: "24px" }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      top: "0px",
                      right: "-1px",
                      width: "7px",
                      height: "7px",
                      borderRadius: "50%",
                      backgroundColor: item.indicatorColor,
                      border: "1px solid white",
                    }}
                  />
                </div>
              )}
              {item.title}
            </div>
          </AccordionSummary>

          <AccordionDetails>{item.content}</AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default AccordionList;
